var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsArray, IsBoolean, IsOptional, IsString } from 'class-validator';
export class UpdateWebhookSubscriptionDto {
    // IsUrl failes for some URLs, so we use IsString and validate manually in the controller
    url;
    events;
    active;
}
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], UpdateWebhookSubscriptionDto.prototype, "url", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Array)
], UpdateWebhookSubscriptionDto.prototype, "events", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateWebhookSubscriptionDto.prototype, "active", void 0);
//# sourceMappingURL=update-webhook-subscription.dto.js.map